module.exports = __webpack_public_path__ + "1cfcc45b68693c0b07132473c0d09de0.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_large_x1/public/history/7.jpg
// module id = 256
// module chunks = 0